import React from 'react';
import classNames from 'classnames';
import useSessionstorage from '@rooks/use-sessionstorage';
import * as EasyQRCode from 'easyqrcodejs';

const formatDate = (milliseconds) => {
  const dateFromMilliseconds = new Date(Number(milliseconds));
  const formatedDate = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(dateFromMilliseconds);
  return formatedDate.toString();
};

export const Response = (props) => {
  const [submitedData] = useSessionstorage('submitedData');

  const { success, siteName, inviteCode, pageData, isEnableQrCodeWithPinInside } = submitedData || {};
  const code = React.createRef();
  const obj = {
    e: `${Date.now() + 28800000}`,
    p: `${inviteCode}`,
  };

  const trimmedSiteName = siteName && siteName.length > 26 ? siteName.substring(0, 26 - 3) + '...' : siteName;
  const expiredDateText = `Expired on ${formatDate(obj.e)}`.toUpperCase();

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  React.useEffect(() => {
    if (submitedData && isEnableQrCodeWithPinInside && success) {
      new EasyQRCode(code.current, {
        text: `${JSON.stringify(obj)}`,
        width: 275,
        height: 275,
        correctLevel: EasyQRCode.CorrectLevel.H,
        quietZone: 15,
        title: trimmedSiteName?.toUpperCase(),
        titleFont: '16px Arial',
        titleHeight: 70,
        titleTop: 25,
        subTitle: expiredDateText,
        subTitleFont: '16px Arial',
        subTitleColor: 'black',
        subTitleTop: 45,
      });
    }
  }, [code, success, expiredDateText, isEnableQrCodeWithPinInside, obj, submitedData, trimmedSiteName]);
  if (!submitedData) {
    return null;
  }
  const { headline, response, bgColor, headlineColor } = pageData;

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementsByTagName('canvas')[0];
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');

    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${siteName}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div
      className={classNames({
        container: true,
        'w-full': true,
        'max-w-xs': true,
        'mx-auto': true,
        'bg-red-gradient': bgColor === 'red',
        'bg-green-gradient': bgColor === 'green',
        'bg-yellow-gradient': bgColor === 'yellow',
        'bg-white-gradient': bgColor === '#fff',
        'bg-black-gradient': bgColor === '#000',
      })}
    >
      <div className="successSubmit px-8 pt-6 pb-8 mb-4 mt-4">
        <br />
        <h1 className="rejectionTitle text-center mt-4" style={{ color: headlineColor }}>
          {headline || 'headline'}
        </h1>
        <p className="text-center text-white successText">{response || 'message'}</p>
        {success && (
          <div className="result">
            {!isEnableQrCodeWithPinInside ? (
              <p className="text-center bigLetters">{inviteCode}</p>
            ) : (
              <div className="flex flex-col justify-center pt-4 mt-5">
                <div className="flex justify-center" ref={code}></div>
                <div className="flex justify-center pt-6">
                  <button type="button" className="buttonDownload font-extrabold" style={{ width: '290px' }} onClick={() => downloadQRCode()}>
                    DOWNLOAD
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
